import image_generateall from "@/Painting/imagegenerate/image_generateall.vue";
import { ArrowDown, ArrowRight } from "@element-plus/icons-vue";
import { isVNode } from "vue";
export default {
  components: {
    image_generateall,
    ArrowDown,
    ArrowRight
  },
  emits: ["startcrop"],
  data() {
    return {
      showImageGenerateAll: false,
      // 是否显示image_generateall组件中的详细对话框
      isshowDetailDialog: false,
      // 是否显示裁剪对话框
      isshowCropDialog: false
    };
  },
  watch: {
    showImageGenerateAll(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  },
  methods: {
    toggleImageGenerateAll() {
      // console.log("toggleImageGenerateAll ", this.showImageGenerateAll);
      this.showImageGenerateAll = !this.showImageGenerateAll;
      this.isshowCropDialog = false;
    },
    startcrop(imgurl) {
      this.$emit("startcrop", imgurl);
      this.isshowCropDialog = true;
    },
    showDetailDialog(showstatus) {
      this.isshowDetailDialog = showstatus;
    },
    onCropOk(result) {
      // console.log("bottom onCropOk ", result);
      // console.log("refs cropok ", this.$refs.imagegenerateall);

      this.$refs.imagegenerateall.onCropOk(result);
      this.isshowCropDialog = false;
    },
    onCropCancel() {
      this.$refs.imagegenerateall.onCropCancel();
      this.isshowCropDialog = false;
    }
  },
  directives: {
    clickOutside: {
      beforeMount(el, binding) {
        el.clickOutsideEvent = function (event) {
          // console.log("clickOutsideEvent ", event);
          // console.log("this showDetailDialog ", binding.instance.isshowDetailDialog);
          // console.log("this showCropDialog ", binding.instance.isshowCropDialog);

          const vm = binding.instance;
          if (vm.isshowDetailDialog === true || vm.isshowCropDialog === true) {
            return;
          }

          // 检查点击是否在 el 之外
          if (!(el === event.target || el.contains(event.target))) {
            // 如果是，在此调用提供的回调函数
            binding.value(event);
          }
        };
        document.addEventListener('click', el.clickOutsideEvent);
      },
      unmounted(el) {
        document.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  }
};